/* Location message — personalized shipping message with visitor geolocation.
   Cache key follows this theme's existing "theme_<feature>_<field>" convention
   (see theme.ShippingProgressBar in theme.js), improved with a 24h TTL. */
(function () {
  if (window.__locationMessageInit) return;
  window.__locationMessageInit = true;

  var CACHE_KEY = 'theme_location_message_cache';
  var CACHE_TTL = 24 * 60 * 60 * 1000; // 24h — one ipwho.is lookup per visitor per day, shared across tabs
  var ANIMATION_MS = 2400;
  var pendingFetch = null;

  function getCachedLocation() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || Date.now() - data.ts > CACHE_TTL) return null;
      return data.location;
    } catch (e) {
      return null;
    }
  }

  function setCachedLocation(location) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), location: location }));
    } catch (e) {}
  }

  function formatDeliveryDate(days) {
    var d = new Date();
    d.setDate(d.getDate() + parseInt(days, 10));
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
  }

  function formatLocation(data, type) {
    if (!data) return null;
    switch (type) {
      case 'country':
        return data.country;
      case 'region':
        return data.region || data.region_code;
      case 'city_region':
        var city = data.city;
        var region = data.region || data.region_code;
        if (city && region) return city + ', ' + region;
        return city || region || data.country;
      case 'city':
      default:
        return data.city || data.region || data.country;
    }
  }

  function fetchVisitorLocation() {
    return fetch('https://ipwho.is/')
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (!data || data.success === false) throw new Error('geo lookup failed');
        return {
          city: data.city,
          region: data.region,
          region_code: data.region_code,
          country: data.country
        };
      })
      .catch(function () {
        var rootPath = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
        var endpoint = (rootPath + 'browsing_context_suggestions.json').replace(/\/+/g, '/');

        return fetch(endpoint)
          .then(function (response) { return response.json(); })
          .then(function (data) {
            var detected = data && data.detected_values;
            var countryName = detected && detected.country && detected.country.name;
            if (!countryName) throw new Error('Shopify fallback failed');
            return { country: countryName };
          });
      });
  }

  function applyDeliveryDates() {
    document.querySelectorAll('[data-location-date]').forEach(function (el) {
      var days = el.getAttribute('data-location-date');
      if (days) el.textContent = formatDeliveryDate(days);
    });
  }

  function applyLocations(locationData) {
    document.querySelectorAll('[data-location-type]').forEach(function (el) {
      var type = el.getAttribute('data-location-type') || 'city';
      var fallback = el.getAttribute('data-location-fallback');
      var placeEl = el.querySelector('[data-location-place]');
      if (!placeEl) return;

      var formatted = formatLocation(locationData, type) || fallback;
      if (formatted) placeEl.textContent = formatted;
    });
  }

  function playAnimations() {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-location-anim]').forEach(function (el) {
      el.classList.remove('is-animating', 'is-complete');

      if (reducedMotion) {
        el.classList.add('is-complete');
        return;
      }

      void el.offsetWidth;
      el.classList.add('is-animating');

      window.setTimeout(function () {
        el.classList.remove('is-animating');
        el.classList.add('is-complete');
      }, ANIMATION_MS);
    });
  }

  function initLocationMessages() {
    if (!document.querySelector('[data-location-type]')) return;

    applyDeliveryDates();
    playAnimations();

    var cached = getCachedLocation();
    if (cached) {
      applyLocations(cached);
      return;
    }

    if (!pendingFetch) {
      pendingFetch = fetchVisitorLocation()
        .then(function (locationData) {
          setCachedLocation(locationData);
          return locationData;
        })
        .catch(function (err) {
          console.warn('Location message: all geolocation routes failed', err);
          return null;
        })
        .finally(function () {
          pendingFetch = null;
        });
    }

    pendingFetch.then(function (locationData) {
      if (locationData) applyLocations(locationData);
    });
  }

  window.themeLocationMessage = { init: initLocationMessages };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLocationMessages);
  } else {
    initLocationMessages();
  }

  document.addEventListener('shopify:section:load', initLocationMessages);
  document.addEventListener('shopify:block:select', initLocationMessages);
})();
